import React, { useState } from 'react';
import { Eye, EyeOff, ExternalLink } from 'lucide-react';

const STEPS = [
  'Sign in to entra.microsoft.com → Identity → Applications → App registrations → New registration (single tenant). Copy the Directory (tenant) ID and Application (client) ID.',
  'API permissions → Add a permission → Microsoft Graph → Application permissions → Mail.Send → Add, then click "Grant admin consent".',
  'Certificates & secrets → New client secret → copy the secret VALUE (not the Secret ID) immediately.',
  'Make sure the Sender Email Address above is a licensed Exchange Online mailbox (or shared mailbox) in the same tenant.',
  'Optional (recommended): restrict the app to this mailbox only using Exchange Online RBAC for Applications.',
];

const Field = ({ label, value, onChange, testId, placeholder, secret }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <div className="relative">
        <input type={secret && !show ? 'password' : 'text'} value={value} onChange={(e) => onChange(e.target.value)}
               className="w-full px-3 py-2 pr-10 border rounded-lg font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
               data-testid={testId} placeholder={placeholder} autoComplete="off" />
        {secret && (
          <button type="button" onClick={() => setShow((s) => !s)} data-testid={`${testId}-toggle`}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
            {show ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
    </div>
  );
};

export const MicrosoftGraphFields = ({ tenantId, setTenantId, clientId, setClientId, secret, setSecret, secretSet }) => (
  <div className="space-y-4" data-testid="ms-graph-fields">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Field label="Directory (Tenant) ID" value={tenantId} onChange={setTenantId} testId="ms-tenant-id" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
      <Field label="Application (Client) ID" value={clientId} onChange={setClientId} testId="ms-client-id" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
    </div>
    <div>
      <Field label={<>Client Secret {secretSet && <span className="text-xs text-green-600 font-normal">(currently set — leave blank to keep)</span>}</>}
             value={secret} onChange={setSecret} testId="ms-client-secret" secret
             placeholder={secretSet ? '••••••••••••••••' : 'Paste the client secret VALUE'} />
      <p className="text-xs text-gray-500 mt-1">Never shown after saving. Used only to obtain Microsoft Graph tokens on the server.</p>
    </div>
    <details className="rounded-lg border border-blue-100 bg-blue-50/50 px-4 py-3 text-sm" data-testid="ms-setup-steps">
      <summary className="cursor-pointer font-medium text-blue-900">One-time Azure setup (5 minutes)</summary>
      <ol className="list-decimal ml-5 mt-2 space-y-1.5 text-gray-700 text-xs">
        {STEPS.map((s) => <li key={s}>{s}</li>)}
      </ol>
      <a href="https://learn.microsoft.com/en-us/graph/api/user-sendmail" target="_blank" rel="noreferrer"
         className="inline-flex items-center gap-1 mt-2 text-xs text-blue-700 hover:underline">
        Microsoft documentation <ExternalLink size={12} />
      </a>
    </details>
  </div>
);
